import React, { Component } from "react";
import axios from "axios";
import { Header, Segment, Message, Loader, Tab } from "semantic-ui-react";
import SalespersonEditForm from "./SalespersonEditForm";

import EntityContractsTable from "components/views/contracts/EntityContractsTable";

export default class SalespersonDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: null,
      data: {
        first_name: "",
        last_name: "",
        email: "",
        id: null,
        phone: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        zip: "",
      },
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { id } = this.props;

    axios
      .get(`/salespeople/${id}`)
      .then((res) => {
        this.setState({
          loading: false,
          data: res.data,
          dealer: res.data.dealer,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: {
            message: err.response.data.ui_message,
          },
        });
      });
  }

  handleChange(data) {
    this.setState({ data });
  }

  render() {
    const { loading, error, data } = this.state;

    const { id } = this.props;

    if (error) {
      return (
        <Segment>
          <Message
            error
            icon="exclamation"
            header="There was a problem"
            content={error.message}
          />
        </Segment>
      );
    }

    if (loading) {
      return <Loader active content="Loading Salesperson" />;
    }

    const edit = (
      <Tab.Pane>
        <SalespersonEditForm data={data} onChange={this.handleChange} />
      </Tab.Pane>
    );

    const panes = [
      { menuItem: "Edit", render: () => edit },
      {
        menuItem: "Contracts",
        render: () => (
          <EntityContractsTable
            fetchUrl={`/salespeople/retrieve-contracts/`}
            salespersonId={id}
          />
        ),
      },
    ];

    return (
      <div>
        <Header
          content={`${data.first_name} ${data.last_name}`}
          as="h2"
          subheader="Salesperson"
        />
        <Tab panes={panes} />
      </div>
    );
  }
}
